import { Badge, Button, Drawer, List, ListItemButton, Tab, styled } from '@mui/material'

export const NotificationTab = styled(Tab)(({ theme }) => ({
  minWidth: '110px',
  minHeight: 'fit-content',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 500,
  padding: '8px 15px 9px',
  lineHeight: '21px',
  textTransform: 'capitalize'
}))

export const CleanButton = styled(Button)(({ theme }) => ({
  '.MuiButton-root': {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary,
    textTransform: 'initial',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      backgroundColor: theme.palette.grey[50]
    },
    [theme.breakpoints.down('md')]: {
      margin: '8px 0px'
    }
  }
}))

export const NotificationList = styled(List)(({ theme }) => ({
  '.MuiList-root': {
    padding: 0,
    maxHeight: 376,
    overflow: 'scroll',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      backgroundColor: theme.palette.grey[200],
      borderRadius: '4px',
      width: '8px',
      margin: '8px',
      '&-thumb': {
        backgroundColor: theme.palette.grey[500],
        borderRadius: '4px'
      }
    },
    [theme.breakpoints.down('md')]: {
      overflow: 'hidden',
      maxHeight: '100%'
    }
  }
}))

export const NotificationListItemButton = styled(ListItemButton)({
  '.MuiListItemButton-root': {
    display: 'flex',
    flexDirection: 'column',
    padding: 0
  }
})

export const StyledBadge = styled(Badge)({
  '.MuiBadge-root': {
    width: 'fit-content'
  },
  '.MuiBadge-anchorOriginTopRightRectangular': {
    right: '-8px',
    top: '6px'
  }
})

export const NotificationDrawerMobile = styled(Drawer)(({ theme }) => ({
  '.MuiDrawer-paper': {
    width: 340,
    paddingTop: '5px',
    border: 'none',
    maxHeight: '-webkit-fill-available',
    height: '-webkit-fill-available',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      backgroundColor: theme.palette.grey[200],
      borderRadius: '4px',
      width: '6px',
      margin: '8px',
      '&-thumb': {
        backgroundColor: theme.palette.grey[500],
        borderRadius: '4px'
      }
    },
    '&.admin': {
      background: theme.palette.grey[900],
      borderRadius: '0px 4px 0px 0px',
      [theme.breakpoints.up('md')]: {
        marginTop: '170px'
      }
    },
    '&.client': {
      background: theme.palette.grey[50],
      [theme.breakpoints.up('md')]: {
        marginTop: '189px'
      }
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 16,
      width: 'calc(100% - 64px)'
    }
  }
}))
